import { TFileUploadStatus } from 'common/types';

export const INITIAL_FILE_STATUS: TFileUploadStatus = {
    done: false,
    success: false,
    progress: 0,
};
